import(/* webpackMode: "eager" */ "/workspace-install/projects/astrolive-app/common/components/AstroStaticPage/index.tsx")